import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GetGuestByUuid } from '../../api/api';

// The page a scanned invitation label opens: /g/<uuid>.
//
// Whoever is holding the card can read it - no sign-in, no OTP - so it shows
// that ONE guest and the functions they are invited to, and nothing about
// anybody else. The id in the QR is random, so the list cannot be walked by
// trying numbers.
export function useGuestCard() {
  const { uuid } = useParams();
  const [state, setState] = useState({ loading: true, error: '', data: null });

  useEffect(() => {
    let dead = false;
    const id = String(uuid || '').trim().toLowerCase();
    if (!/^[0-9a-f]{32}$/.test(id)) {
      setState({ loading: false, error: 'That is not an invitation code.', data: null });
      return undefined;
    }
    setState({ loading: true, error: '', data: null });
    GetGuestByUuid({ Uuid: id })
      .then(d => { if (!dead) setState({ loading: false, error: '', data: d }); })
      .catch(err => {
        if (dead) return;
        const status = err?.response?.status;
        setState({
          loading: false,
          data: null,
          error: status === 404
            ? 'This code does not belong to any guest. It may have been removed from the list.'
            : 'Could not read the code — check the connection and try again.',
        });
      });
    return () => { dead = true; };
  }, [uuid]);

  const guest = state.data?.Guest || null;
  const fullName = guest
    ? [guest.Surname, guest.GuestName, guest.FatherHusband].filter(Boolean).join(' ').trim()
    : '';

  return {
    ...state,
    uuid,
    guest,
    fullName,
    event: state.data?.Event || null,
    functions: state.data?.Functions || [],
  };
}
